import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft, CheckCircle, Loader2 } from 'lucide-react';
import { authApi } from '../services/api';
import { AuthBrand } from '../components/AuthBrand';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);
    try {
      await authApi.forgotPassword(email);
      setSuccess(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to send reset email');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4">
      <div className="relative w-full max-w-md animate-fade-in">
        <AuthBrand />
        <div className="bg-background-secondary border border-border rounded-xl p-8 shadow-xl">
          {success ? (
            <div className="text-center">
              <CheckCircle className="w-12 h-12 text-accent mx-auto mb-4" />
              <h1 className="text-xl font-semibold mb-3">Check Your Email</h1>
              <p className="text-sm text-foreground-secondary mb-8">
                If an account exists for {email}, a reset link has been sent.
              </p>
              <Link to="/login" className="inline-flex items-center gap-2 text-accent">
                <ArrowLeft className="w-4 h-4" /> Back to Sign In
              </Link>
            </div>
          ) : (
            <>
              <div className="flex items-center gap-3 mb-6">
                <Mail className="w-5 h-5 text-accent" />
                <h1 className="text-xl font-semibold">Reset Password</h1>
              </div>
              {error && <div className="mb-6 p-3 bg-error/10 border border-error/20 rounded-lg text-sm text-error">{error}</div>}
              <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                  <label htmlFor="email" className="label">Email</label>
                  <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="input" required autoFocus />
                </div>
                <button type="submit" disabled={isLoading} className="btn-primary w-full py-2.5">
                  {isLoading ? <><Loader2 className="w-4 h-4 animate-spin" />Sending...</> : 'Send Reset Link'}
                </button>
              </form>
              <div className="mt-6 text-center text-sm">
                <Link to="/login" className="text-accent">Back to sign in</Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
